var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',[_c('b-form-checkbox-group',{attrs:{"id":"timeline-config","options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_c('div',{attrs:{"id":"timelineVisualization"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }